import { aiArtworks } from "../data/aiArtworks";
import { canvasArtworks, type CanvasArtwork } from "../data/canvasArtworks";
import { digitalArtworks } from "../data/digitalArtworks";
import type { ArtworkMedium } from "./artworkPaths";

export function relatedCanvasArtworks(
  collection: CanvasArtwork["collection"],
  excludeId: string,
): CanvasArtwork[] {
  return canvasArtworks.filter(
    (work) => work.collection === collection && work.id !== excludeId,
  );
}

export function relatedAiArtworks(
  collection: (typeof aiArtworks)[number]["collection"],
  excludeId: string,
) {
  return aiArtworks.filter(
    (work) => work.collection === collection && work.id !== excludeId,
  );
}

export function relatedDigitalArtworks(
  collection: (typeof digitalArtworks)[number]["collection"],
  excludeId: string,
) {
  return digitalArtworks.filter(
    (work) => work.collection === collection && work.id !== excludeId,
  );
}

export type RelatedArtworkItem =
  | { medium: "canvas"; work: CanvasArtwork }
  | { medium: "ai"; work: (typeof aiArtworks)[number] }
  | { medium: "digital"; work: (typeof digitalArtworks)[number] };

export function relatedArtworksFor(
  medium: ArtworkMedium,
  collection: string,
  excludeId: string,
): RelatedArtworkItem[] {
  if (medium === "canvas") {
    return relatedCanvasArtworks(
      collection as CanvasArtwork["collection"],
      excludeId,
    ).map((work) => ({ medium: "canvas", work }));
  }
  if (medium === "ai") {
    return relatedAiArtworks(
      collection as (typeof aiArtworks)[number]["collection"],
      excludeId,
    ).map((work) => ({ medium: "ai", work }));
  }
  return relatedDigitalArtworks(
    collection as (typeof digitalArtworks)[number]["collection"],
    excludeId,
  ).map((work) => ({ medium: "digital", work }));
}
